import { render, staticRenderFns } from "./TagChatSystem.vue?vue&type=template&id=6b200d20&scoped=true"
import script from "./TagChatSystem.vue?vue&type=script&lang=js"
export * from "./TagChatSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b200d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b200d20')) {
      api.createRecord('6b200d20', component.options)
    } else {
      api.reload('6b200d20', component.options)
    }
    module.hot.accept("./TagChatSystem.vue?vue&type=template&id=6b200d20&scoped=true", function () {
      api.rerender('6b200d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/tag/TagChatSystem.vue"
export default component.exports